<template>
        
        
    
</template>

<script>

export default {
    name: 'Site',
    data: vm => ({
        
    }),
    // computed: {
    //     computedDateFormatted () {
    //         return this.formatDate(this.dateStart)
    //     }
    // },
    // watch: {
    //     date (val) {
    //         this.dateFormatted = this.formatDate(this.dateStart)
    //     }
    // },
    methods: { // ####################### Criar parte que criar documentos collections de cada escola ao realizar primeiro login do usuario Escola
            
            
        
    },
    mounted() {
        this.$nextTick(function () {


        })
    }
};
</script>

<style>
    .v-toolbar.v-toolbar--fixed.theme--dark.brown.darken-4 .v-toolbar__content a, .v-toolbar.v-toolbar--fixed.theme--dark.brown.darken-4 .v-toolbar__content div, .v-item-group.v-bottom-nav.theme--dark{
        display: none !important
    }
</style>
